import ErrorBoundary from "@/components/ErrorBoundary";
import { Spinner } from "@/components/ui/kibo-ui/spinner";
import Trackker from "@/utils/tracker";
import { Suspense, lazy } from "react"; // lazy'yi import ediyoruz
import { BrowserRouter, Route, Routes } from "react-router-dom";

// --- TÜM SAYFALARI VE ANA YERLEŞİMİ (LAYOUT) LAZY OLARAK TANIMLIYORUZ ---
// Her bir sayfa artık kendi JavaScript dosyasına sahip olacak ve sadece ihtiyaç duyulduğunda yüklenecek.
const Container = lazy(() => import("@/Containers/index.jsx"));
const HomePage = lazy(() => import("@/Containers/Home/"));
const Library = lazy(() => import("@/Containers/Library/"));
const Builder = lazy(() => import("@/Containers/ChecklistBuilder/"));
const TermsPage = lazy(() => import("@/Containers/Legal/TermsPage"));
const PrivacyPolicyPage = lazy(() =>
  import("./Containers/Legal/PrivacyPolicyPage")
); // Bu path'i de olduğu gibi bıraktım
const AboutPage = lazy(() => import("@/Containers/About/"));
const SupportPage = lazy(() => import("@/Containers/Support/"));
const ContactPage = lazy(() => import("@/Containers/Contact/"));

export default function App() {
  return (
    <ErrorBoundary>
      {/* Suspense, lazy component'ler yüklenirken ne gösterileceğini belirler. */}
      <Suspense
        fallback={
          <div className="grid place-items-center h-screen">
            {" "}
            {/* JSX'te 'class' yerine 'className' kullanılır. */}
            <Spinner key="1" variant={"ellipsis"} />
          </div>
        }
      >
        <BrowserRouter>
          {/* Tracker gibi uygulama başlar başlamaz çalışması gereken component'leri Suspense dışında veya statik tutabiliriz. */}
          <Trackker />
          <Routes>
            {/* Ana Container'ı da lazy yaptığımız için artık o da Suspense'in nimetlerinden faydalanıyor. */}
            <Route path="/" element={<Container />}>
              <Route index element={<HomePage />} />
              <Route path="/library" element={<Library />} />
              <Route path="/terms" element={<TermsPage />} />
              <Route path="/privacy" element={<PrivacyPolicyPage />} />
              <Route path="/builder" element={<Builder />} />
              <Route path="/about" element={<AboutPage />} />
              {/* Not: Orijinal kodda /support olan yolu /help olarak değiştirmişsin, ben de ona uydum. */}
              <Route path="/help" element={<SupportPage />} />
              <Route path="/contact" element={<ContactPage />} />
            </Route>
          </Routes>
        </BrowserRouter>
      </Suspense>
    </ErrorBoundary>
  );
}
